import { styled } from '@mui/material';

import { Skeleton } from '../../atoms/Skeleton';
import { MESSAGE_LIST_WIDE_QUERY } from '../MessageList/messageListContainer';

const AVATAR_SIZE = 40;
const AVATAR_SIZE_WIDE = 32;

const Row = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: `${AVATAR_SIZE}px minmax(0, 1fr)`,
  columnGap: theme.spacing(1.5),
  paddingBlock: theme.spacing(1.5),
  paddingInline: theme.spacing(2),
  [MESSAGE_LIST_WIDE_QUERY]: {
    gridTemplateColumns: `${AVATAR_SIZE_WIDE}px minmax(0, 1fr)`,
    columnGap: theme.spacing(2),
    alignItems: 'center',
    paddingBlock: theme.spacing(1),
    minHeight: theme.spacing(7),
  },
}));

const AvatarSlot = styled('span')({
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
  [MESSAGE_LIST_WIDE_QUERY]: {
    width: AVATAR_SIZE_WIDE,
    height: AVATAR_SIZE_WIDE,
  },
});

const Lines = styled('span')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  [MESSAGE_LIST_WIDE_QUERY]: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}));

const Line = styled('span')<{ ownerState: { width: string } }>(({ ownerState }) => ({
  display: 'block',
  width: ownerState.width,
}));

/** Placeholder row matching `MessageListItem` while messages load. */
export function MessageListItemSkeleton() {
  return (
    <li aria-hidden="true" data-testid="message-list-item-skeleton">
      <Row>
        <AvatarSlot>
          <Skeleton variant="circular" width="100%" height="100%" />
        </AvatarSlot>
        <Lines>
          <Line ownerState={{ width: '40%' }}><Skeleton variant="text" /></Line>
          <Line ownerState={{ width: '70%' }}><Skeleton variant="text" /></Line>
          <Line ownerState={{ width: '90%' }}><Skeleton variant="text" /></Line>
        </Lines>
      </Row>
    </li>
  );
}
